import { FC } from 'react'
import { PreferenciasSus, QuandoGerarSus } from '../../core/documentosSus'
import styles from '../../Prescricao.module.scss'
import { Radio } from 'app/components'
import { useRotulos } from '../comum/useRotulos'

type IProps = {
  /** Nomes dos itens com LME e APAC; vazio esconde o bloco correspondente. */
  itensLme: string[]
  itensApac: string[]
  preferencias: PreferenciasSus
  onChange: (preferencias: PreferenciasSus) => void
}

const OPCOES: QuandoGerarSus[] = ['apos_assinar', 'depois']

/** LME e APAC exigem a receita assinada: aqui o médico só escolhe se gera logo em seguida. */
export const SecaoSus: FC<IProps> = ({ itensLme, itensApac, preferencias, onChange }) => {
  const { t } = useRotulos()
  if (itensLme.length === 0 && itensApac.length === 0) return null

  const bloco = (documento: 'lme' | 'apac', itens: string[]) => (
    <fieldset className={documento === 'lme' ? styles.caixaLme : styles.caixaApac}>
      <legend className='float-start w-100 d-flex flex-wrap align-items-center gap-2 fs-7 fw-bold mb-2'>
        <span
          className={`${styles.selo} ${documento === 'lme' ? styles.seloLme : styles.seloApac}`}
        >
          {t(`prescricao.selo.${documento}`)}
        </span>
        {itens.join(', ')}
      </legend>
      <Radio
        id={`revisao-${documento}`}
        size='sm'
        value={preferencias[documento]}
        onChange={(opcao) => onChange({ ...preferencias, [documento]: opcao })}
        options={OPCOES.map((opcao) => ({
          id: opcao,
          value: opcao,
          descricao: t(`prescricao.sus.${opcao}`),
        }))}
      />
      <span className='fs-7 d-block mt-2'>
        {preferencias[documento] === 'apos_assinar'
          ? t(`prescricao.sus.dica_${documento}`)
          : t('prescricao.sus.dica_depois')}
      </span>
    </fieldset>
  )

  return (
    <section aria-labelledby='revisao-sus' className={`${styles.secao} d-flex flex-column gap-3`}>
      <div>
        <h3 id='revisao-sus' className='fs-6 fw-bold m-0'>
          {t('prescricao.sus.titulo')}
        </h3>
        <span className={`fs-7 ${styles.textoSecundario}`}>{t('prescricao.sus.explicacao')}</span>
      </div>
      {itensLme.length > 0 && bloco('lme', itensLme)}
      {itensApac.length > 0 && bloco('apac', itensApac)}
    </section>
  )
}
